import React, { useState, useEffect } from 'react'
import Api from '../services/Api';
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactUs({ client, project }) {
    const DP_RECAPTCHA_SITE_KEY = "6Lc3qtshAAAAAEwpuJpQbVVQgRTK_aokG9DQDNvH";
    const R2_RECAPTCHA_SITE_KEY = "6LfFY2ceAAAAAJXV074rilue2eQcfhpu_aSPootQ";

    const ERROR_MSG = {
        title: 'Information Missing!',
        subtitle: 'Please fill out the red highlighted fields.',
        error: true
    };

    const R2_SUCCESS_MSG = {
        title: 'Thanks for your interest!',
        subtitle: `We'll reach out to you as soon as we can.`,
        error: false
    };

    const DP_SUCCESS_MSG = {
        title: 'Thanks for reaching out!',
        subtitle: `You'll hear from us shortly.`,
        error: false
    };

    const [countriesList, setCountries] = useState([{
        id: 0,
        name: 'Select a country'
    }]);

    const [dataSubjectTypes, setDataSubjectTypes] = useState([]);
    const [requestTypes, setRequestTypes] = useState([]);
    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
        country: 0,
        description: '',
        request_type_ids: [],
        data_subject_type_id: 0,
        recaptcha: ''
    });
    const [isValid, setIsValid] = useState(true);
    const [validationMsg, setValidationMsg] = useState(null);

    useEffect(() => {
        getDropdowns();
    }, [project])

    const getDropdowns = async () => {
        if (project) {
            const { countries, dataSubjectTypes, requestTypes } = await Api.getDropdowns(project?.id);
            setCountries(countriesList.concat(countries));

            if (dataSubjectTypes.length === 1) {
                setForm({ ...form, data_subject_type_id: dataSubjectTypes[0].id })
            }

            setDataSubjectTypes(dataSubjectTypes);
            setRequestTypes(requestTypes);
        }
    }

    const selectDataSubjectType = (e, data_subject_type_id) => {
        e.preventDefault();
        e.stopPropagation();
        setForm({ ...form, data_subject_type_id })
    }

    const toggleRequestType = (e, id) => {
        e.preventDefault();
        e.stopPropagation();

        let itemIndex = -1;

        if (form.request_type_ids && form.request_type_ids.length > 0) {
            itemIndex = form.request_type_ids.indexOf(id);
        } else {
            form.request_type_ids = [];
        }

        if (itemIndex !== -1) {
            form.request_type_ids.splice(itemIndex, 1)
        } else {
            form.request_type_ids.push(id);
        }

        setForm({ ...form, request_type_ids: form.request_type_ids })
    }

    const validate = () => {
        let isValid = true;

        if (!project) {
            delete form.data_subject_type_id;
            delete form.request_type_ids;
        }

        const keys = Object.keys(form);
        for (let i = 0; i < keys.length; i++) {
            // Check for request_type_ids since its an array
            if (keys[i] === "request_type_ids" && (!form[keys[i]] || form[keys[i]].length === 0)) {
                isValid = false;
                break
            }
            else if (!form[keys[i]]) {
                isValid = false;
                break;
            }
        }

        return isValid;
    }

    const submitForm = async () => {
        // const isValid = validate();
        // setIsValid(isValid);
        // if (!isValid) {
        //     setValidationMsg(ERROR_MSG);
        // }
        // else {
        if (project) {
            delete form.recaptcha;
            form.project_id = project.id;
            const response = await Api.submitRequest(form);
            setValidationMsg(DP_SUCCESS_MSG);
        }
        else {
            const data = {
                name: form.first_name + " " + form.last_name,
                email: form.email_address,
                phone_number: form.phone_number,
                subject: "Request from Data Privacy",
                message: form.description + "\n" + form.country,
                token: form.recaptcha
            };

            const response = await Api.sendR2Email(data);

            setValidationMsg(R2_SUCCESS_MSG);
            setForm({
                first_name: '',
                last_name: '',
                email_address: '',
                phone_number: '',
                country: 0,
                description: '',
                request_type_ids: [],
                data_subject_type_id: 0,
                recaptcha: ''
            })
        }
        // }
    }

    return (
        <div className="relative overflow-hidden" style={{ backgroundColor: `rgba(23, 106, 184, 0.8)` }}>
            <div style={{ backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), url(/images/bg2.png)` }}>
                <div className="mx-auto max-w-7xl">
                    <div className="relative z-10 pb-8 sm:pb-16 md:pb-20 lg:w-full lg:pb-28 xl:pb-32">
                        <main className="mx-auto pt-5 max-w-7xl px-4 sm:pt-6 sm:px-6 md:pt-8 lg:pt-10 lg:px-8 xl:pt-14">
                            <div className="sm:text-center lg:text-left">
                                <h3 className="text-2xl font-light tracking-tight sm:text-2xl md:text-3xl">
                                    <span className="block text-blue-600 xl:inline">Fill out the form</span>
                                </h3>
                                <p className="mt-3 text-base text-gray-500 sm:mx-auto sm:mt-5 sm:text-lg md:mt-5 md:text-xl lg:mx-0">
                                    {
                                        project ?
                                            `Please complete the form below and submit your request for processing. Once submitted, you will receive an e-mail, at the address you have provided in your request, confirming that the submission was successful. Further e-mail correspondence will soon follow seeking to confirm your identity prior to proceeding with your submitted request.`
                                            :
                                            `Please reach out to us to setup the Data Privacy portal for your company`
                                    }
                                </p>
                                <div className="mt-10 md:col-span-2 md:mt-10">
                                    <form className={`md:grid md:gap-24 ${project ? "md:grid-cols-2" : "md:grid-cols-1"}`}>
                                        <div>
                                            <div className="col-span-6 sm:col-span-3">
                                                <label htmlFor="first_name" className={`block text-sm font-medium text-gray-700 ${!isValid ? form.first_name ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>First name</label>
                                                <input type="text" id="first_name" autoComplete="given-name"
                                                    value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })}
                                                    placeholder='Enter your first name here'
                                                    className="mt-3 block w-full rounded-md pl-[14px] shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm h-10" />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3 mt-8">
                                                <label htmlFor="last_name" className={`block text-sm font-medium text-gray-700 ${!isValid ? form.last_name ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>Last name</label>
                                                <input type="text" name="last_name" id="last_name" autoComplete="family-name"

                                                    value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })}
                                                    placeholder='Enter your last name here'
                                                    className="mt-3 block w-full rounded-md pl-[14px] border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm h-10" />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3 mt-8">
                                                <label htmlFor="email_address" className={`block text-sm font-medium text-gray-700 ${!isValid ? form.email_address ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>Email Address</label>
                                                <input type="text" name="email_address" id="email_address" autoComplete="email"
                                                    value={form.email_address} onChange={(e) => setForm({ ...form, email_address: e.target.value })}
                                                    placeholder='Enter your email address here'
                                                    className="mt-3 block w-full rounded-md pl-[14px] border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm h-10" />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3 mt-8">
                                                <label htmlFor="phone_number" className={`block text-sm font-medium text-gray-700 ${!isValid ? form.phone_number ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>Phone Number</label>
                                                <input type="text" name="phone_number" id="phone_number" autoComplete="email"
                                                    value={form.phone_number} onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
                                                    placeholder='Enter your phone number here'
                                                    className="mt-3 block w-full rounded-md pl-[14px] border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm h-10" />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3 mt-8">
                                                <label htmlFor="country" className={`block text-sm font-medium text-gray-700 ${!isValid ? form.country ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>Country</label>
                                                <select id="country" name="country" autoComplete="country-name"
                                                    value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })}
                                                    className="mt-3 pl-[14px] block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm h-10">
                                                    {
                                                        countriesList.map(c => <option>{c.name}</option>)
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-span-6 sm:col-span-3 mt-8">
                                                <label htmlFor="description" className={`block text-sm font-medium text-gray-700 ${!isValid ? form.description ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>Request Details</label>
                                                <textarea id="description" name="description" rows="3" placeholder="Enter your message here"
                                                    value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
                                                    className="mt-3 pl-[14px] block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm sm:text-sm" />
                                            </div>
                                        </div>
                                        {
                                            project && <div>
                                                <div className="col-span-6 sm:col-span-3">
                                                    <label htmlFor="data_subject_type" className={`block text-sm font-medium text-gray-700 ${!isValid && client && project ? form.data_subject_type_id ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>I am a</label>
                                                    {
                                                        dataSubjectTypes.map(d => <>
                                                            <button className={`rounded-md px-4 py-2 mx-2 my-2 border-solid border-2 border-gray-500 bg-white ${form.data_subject_type_id === d.id && 'bg-blue-200'}`}
                                                                onClick={e => selectDataSubjectType(e, d.id)}>
                                                                {d.name}
                                                            </button>
                                                            &nbsp;
                                                        </>)
                                                    }
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 mt-8">
                                                    <label htmlFor="request_type" className={`block text-sm font-medium text-gray-700 ${!isValid && project ? form.request_type_ids && form.request_type_ids.length > 0 ? "text-gray-700" : "text-red-600" : "text-gray-700"}`}>Select Request Type(s)</label>
                                                    {
                                                        requestTypes.map(r => <>
                                                            <button
                                                                onClick={(e) => toggleRequestType(e, r.id)}
                                                                className={`rounded-md px-4 py-2 mx-2 my-2 border-solid border-2 border-gray-500 bg-white ${form.request_type_ids && form.request_type_ids.indexOf(r.id) !== -1 && 'bg-blue-200'}`}>
                                                                {r.name}
                                                            </button>
                                                            &nbsp;
                                                        </>)
                                                    }
                                                </div>
                                                <div className="col-span-6 sm:col-span-3 mt-8">
                                                    <ReCAPTCHA
                                                        sitekey={DP_RECAPTCHA_SITE_KEY}
                                                        onChange={(recaptcha) => setForm({ ...form, recaptcha })}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </form>
                                    <div className='text-center'>
                                        {
                                            project ?
                                                null
                                                :
                                                <ReCAPTCHA
                                                    sitekey={R2_RECAPTCHA_SITE_KEY}
                                                    onChange={(recaptcha) => setForm({ ...form, recaptcha })}
                                                />
                                        }
                                        <button onClick={submitForm} className="rounded-md px-16 py-3 mx-2 my-10 bg-blue-900 text-white">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
                <div style={{ textAlign: 'center', width: '100%', paddingBottom: 10, fontSize: 'small' }}>Powered by <a className='text-blue-600' target='_blank' href='https://www.r2c.io'>R2 Consulting</a></div>
            </div>
            {
                validationMsg && <div aria-live="assertive" className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6" style={{ zIndex: 99 }}>
                    <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                        <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className={`text-sm font-medium ${validationMsg.error ? "text-red-600" : "text-green-600"}`}>{validationMsg.title}</p>
                                        <p className="mt-1 text-sm text-gray-500">{validationMsg.subtitle}</p>
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button type="button"
                                            onClick={() => setValidationMsg(null)}
                                            className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                            <span className="sr-only">Close</span>
                                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
